
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IContactTags, IUpdateContactTags } from '@shared/services/api/legacy/contacttags-service/contacttags-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class ContacttagsService {

  constructor(private http: HttpClient) { }

  private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${ContacttagsService.ENDPOINT}`; }
  private static readonly ENDPOINT = '/tags';

  public getTagsFields(): Observable<SuccessResponse<IContactTags> | ErrorResponse> {
    return this.http
    .get<SuccessResponse<IContactTags>>(ContacttagsService.URL).pipe(
    catchError(error => observableOf(new ErrorResponse(error.error))));
  }

  public updateTagsFields(submitData: IUpdateContactTags): Observable<SuccessResponse<boolean> | ErrorResponse> {
    return this.http
    .put<SuccessResponse<boolean>>(ContacttagsService.URL, submitData).pipe(
    catchError(error => observableOf(new ErrorResponse(error.error))));
  }

}
